<div class="row" *ngIf="loading">
  <div class="loader">Loading...</div>
</div>

<div class="row mb-3" *ngIf="loaded">
  <div class="col-6 align-self-center">
    <h3>{{keyword.shortCode}} | {{keyword.keyword}}</h3>
  </div>
  <div class="col-6 text-right align-self-center">
    <button class="btn btn-default mr-2" (click)="back()">Back</button>
    <button class="btn btn-primary" (click)="save()">Save</button>
  </div>
</div>

<div class="card" *ngIf="loaded">
  <div class="card-header lead font-weight-bold">
    Keyword Detail
  </div>
  <div class="card-body">
    <div class="row">
      <div class="col-12">
        <small><i class="text-danger">* indicates mandatory field</i></small>
      </div>
      <div class="col-5">
        <dl class="row">
          <dt class="col-sm-6 text-center">
            <span class="badge badge-pill badge-primary bg-gradient">General</span>
          </dt>
          <dl class="row mt-3">
            <dt class="col-sm-4 text-right">Created At :</dt>
            <dd class="col-sm-8">{{keyword.createdAt | date: 'medium'}}</dd>
            <dt class="col-sm-4 text-right align-self-center">Source :</dt>
            <dd class="col-sm-8">
              {{keyword.sourceView}}
            </dd>
            <dt class="col-sm-4 text-right">Country :</dt>
            <dd class="col-sm-8">
              <div *ngFor="let country of countryList">
                <span *ngIf="country.code == keyword.country">{{country.name}}</span>
              </div>
            </dd>
            <dt class="col-sm-4 text-right">Operator :</dt>
            <dd class="col-sm-8">
              {{keyword.operator}}
            </dd>
            <dt class="col-sm-4 text-right">Short Code :</dt>
            <dd class="col-sm-8">{{keyword.shortCode}}</dd>
            <dt class="col-sm-4 text-right">Keyword :</dt>
            <dd class="col-sm-8">{{keyword.keyword}}</dd>
            <dt class="col-sm-4 text-right align-self-center">Type :</dt>
            <dd class="col-sm-8">
              {{keyword.typeView}}
            </dd>
            <dt class="col-sm-4 text-right align-self-center">Category :</dt>
            <dd class="col-sm-8">
              {{keyword.categoryView}}
            </dd>
            <dt class="col-sm-4 text-right">Currency :</dt>
            <dd class="col-sm-8">
              {{keyword.currency}}
            </dd>
            <dt class="col-sm-4 text-right"> Affiliate for PSMS :</dt>
            <dd class="col-sm-8">
              SMS
            </dd>
            <dt class="col-sm-4 text-right align-self-center">Price :</dt>
            <dd class="col-sm-8">
              <input type="number" [(ngModel)]="keyword.price" class="form-control">
            </dd>
            <dt class="col-sm-4 text-right align-self-center">* Interval :</dt>
            <dd class="col-sm-8">
              <select class="form-control" placeholder="Select" [(ngModel)]="keyword.interval">
                <option *ngFor="let interval of intervalList | keyvalue" [value]="interval.key">{{interval.value}}</option>
              </select>
            </dd>
            <dt class="col-sm-4 text-right align-self-center">
              <i class="fas fa-question-circle" placement="top"></i> &nbsp;<a target="_blank" [routerLink]="['/dashboard/support/schedule']">View usage</a><br>
              * Schedules :</dt>
            <dd class="col-sm-8">
              <input type="text" [(ngModel)]="keyword.schedules" class="form-control" placeholder="Schedules(split by ,)" />
            </dd>
            <dt class="col-sm-4 text-right align-self-center"><i class="fas fa-info-circle" placement="top" ngbTooltip="It should be uppercase"></i> Premium Service :</dt>
            <dd class="col-sm-8">
              <input type="text" [(ngModel)]="keyword.premiumService" class="form-control" placeholder="Premium Service ID" />
            </dd>

            <dt class="col-sm-4 text-right align-self-center">* Affiliate Enabled :</dt>
            <dd class="col-sm-8">
              <select class="form-control" placeholder="Select" [(ngModel)]="keyword.affiliateEnabled" placeholder="select" disabled="{{affiliateSelectionDisabled}}" >
                <option value="false">Disabled</option>
                <option value="true">Enabled</option>
              </select>
            </dd>
            <dt class="col-sm-4 text-right align-self-center">* Affiliate From ClickId :</dt>
            <dd class="col-sm-8">
              <select class="form-control" placeholder="Select" [(ngModel)]="keyword.affiliateClickEnabled" placeholder="select">
                <option value="false">NO</option>
                <option value="true">YES</option>
              </select>
            </dd>

            <dt class="col-sm-4 text-right align-self-center">SpiderAccount :</dt>
            <dd class="col-sm-8">
              <select class="form-control" placeholder="Select" [(ngModel)]="keyword.spiderAccountId" placeholder="select">
                <option value=null selected>- select account -</option>
                <option *ngFor="let account of spiderAccountList" [value]="account.id">{{account.name}}</option>
              </select>
            </dd>
            <dt class="col-sm-4 text-right align-self-center">ReminderPeriod :</dt>
            <dd class="col-sm-8">
              <select class="form-control" placeholder="Select" [(ngModel)]="keyword.reminderPeriod" placeholder="select">
                <option value=null selected>- select period -</option>
                <option *ngFor="let period of reminderPeriodList" [value]="period.code">{{period.name}}</option>
              </select>
            </dd>
          </dl>
        </dl>
      </div>
      <div class="col-7">
          <dt class="col-sm-6 text-center">
              <span class="badge badge-pill badge-primary bg-gradient">Postback Rate</span>
            </dt>
            <dl class="row">
              <dt class="col-sm-4 text-right align-self-center"><i class="fas fa-info-circle" placement="top" ngbTooltip="0-100"></i> MO Post-back Rate: </dt>
              <dd class="col-sm-8">
                <input type="number" [(ngModel)]="keyword.moPostBackRate" class="form-control" placeholder="MO Post-back Rate"  min="0" max="100">
              </dd>
              <dt class="col-sm-4 text-right align-self-center"><i class="fas fa-info-circle" placement="top" ngbTooltip="0-100"></i> DN Post-back Rate: </dt>
              <dd class="col-sm-8">
                <input type="number" [(ngModel)]="keyword.dnPostBackRate" class="form-control" placeholder="DN Post-back Rate" min="0" max="100">
              </dd>
              <dt class="col-sm-4 text-right align-self-center"><i class="fas fa-info-circle" placement="top" ngbTooltip="0-100"></i> Conversion Post-back Rate: </dt>
              <dd class="col-sm-8">
                <input type="number" [(ngModel)]="keyword.cnvPostBackRate" class="form-control" placeholder="Conversion Post-back Rate" min="0" max="100">
              </dd>
            </dl>

        <dt class="col-sm-6 text-center">
          <span class="badge badge-pill badge-primary bg-gradient">Postback Min</span>
        </dt>
        <dl class="row">
          <dt class="col-sm-4 text-right align-self-center"><i class="fas fa-info-circle" placement="top" ngbTooltip="Less than or equal to 0 means no limit"></i> MO Min: </dt>
          <dd class="col-sm-8">
            <input type="number" [(ngModel)]="keyword.moMin" class="form-control" placeholder="MO Min">
          </dd>
          <dt class="col-sm-4 text-right align-self-center"><i class="fas fa-info-circle" placement="top" ngbTooltip="Less than or equal to 0 means no limit"></i> DN Min: </dt>
          <dd class="col-sm-8">
            <input type="number" [(ngModel)]="keyword.dnMin" class="form-control" placeholder="DN Min">
          </dd>
          <dt class="col-sm-4 text-right align-self-center"><i class="fas fa-info-circle" placement="top" ngbTooltip="Less than or equal to 0 means no limit"></i> Conversion Min: </dt>
          <dd class="col-sm-8">
            <input type="number" [(ngModel)]="keyword.cnvMin" class="form-control" placeholder="Conversion Min">
          </dd>
        </dl>
        <dt class="col-sm-6 text-center">
          <span class="badge badge-pill badge-primary bg-gradient">Postback Cap</span>
        </dt>
        <dl class="row">
          <dt class="col-sm-4 text-right align-self-center"><i class="fas fa-info-circle" placement="top" ngbTooltip="Less than or equal to 0 means no limit"></i> MO Cap: </dt>
          <dd class="col-sm-8">
            <input type="number" [(ngModel)]="keyword.moCap" class="form-control" placeholder="MO Cap">
          </dd>
          <dt class="col-sm-4 text-right align-self-center"><i class="fas fa-info-circle" placement="top" ngbTooltip="Less than or equal to 0 means no limit"></i> DN Cap: </dt>
          <dd class="col-sm-8">
            <input type="number" [(ngModel)]="keyword.dnCap" class="form-control" placeholder="DN Cap">
          </dd>
          <dt class="col-sm-4 text-right align-self-center"><i class="fas fa-info-circle" placement="top" ngbTooltip="Less than or equal to 0 means no limit"></i> Conversion Cap: </dt>
          <dd class="col-sm-8">
            <input type="number" [(ngModel)]="keyword.cnvCap" class="form-control" placeholder="Conversion Cap">
          </dd>
        </dl>
        <dt class="col-sm-6 text-center">
          <span class="badge badge-pill badge-primary bg-gradient">Postback URL</span>
        </dt>
        <dl class="row">
          <dt class="col-sm-4 text-right align-self-center">Mo Postback Url:</dt>
          <dd class="col-sm-8">
            <input type="text" [(ngModel)]="keyword.moNotifyUrl" class="form-control" placeholder="MO postback url">
          </dd>
          <dt class="col-sm-4 text-right align-self-center">Dn Postback Url:</dt>
          <dd class="col-sm-8">
            <input type="text" [(ngModel)]="keyword.dnNotifyUrl" class="form-control" placeholder="DN postback url">
          </dd>
          <dt class="col-sm-4 text-right align-self-center"><i class="fas fa-info-circle" placement="top" ngbTooltip="Macro of clickId: {click_id}"></i> Conversion Url :</dt>
          <dd class="col-sm-8">
            <input type="text" [(ngModel)]="keyword.cnvUrl" class="form-control" placeholder="Conversion postback url">
          </dd>
        </dl>
        <dt class="col-sm-6 text-center">
          <span class="badge badge-pill badge-primary bg-gradient">Report</span>
        </dt>
        <dl class="row">
          <dt class="col-sm-4 text-right align-self-center">Client :</dt>
          <dd class="col-sm-8">
            <select class="form-control" placeholder="Select" [(ngModel)]="keyword.managerId" placeholder="select">
              <option value=null selected>- select client -</option>
              <option *ngFor="let client of clientList" [value]="client.id">{{client.username}}</option>
            </select>
          </dd>
          <dt class="col-sm-4 text-right align-self-center">Share :</dt>
          <dd class="col-sm-8">
            <input type="text" [(ngModel)]="keyword.share" class="form-control" placeholder="share label">
          </dd>
          <dt class="col-sm-4 text-right align-self-center">Revenue Share Ratio :</dt>
          <dd class="col-sm-8">
            <input type="number" min="0" [(ngModel)]="keyword.revenueShareRatio" class="form-control" placeholder="Revenue Share Ratio">
          </dd>
        </dl>
      </div>
    </div>

  </div>
</div>
